type Response = { statusCode: number; data?: any };
type AttachmentApi = {
  getFlowAttachments(options: any): Promise<Response>;
  createFlowAttachment(data: any): Promise<Response>;
  deleteFlowAttachment(id: string): Promise<Response>;
};

// Always read the saved target. A cached attachment may belong to a previously
// selected phone, or may have been removed by another administrator.
export async function saveWhatsAppFlowAttachment(
  api: AttachmentApi, settingsId: string, phoneId: string, flowId?: string,
) {
  const existing = await api.getFlowAttachments({
    scope: 'channel_settings', attachedTo: settingsId, isActive: true,
    triggerType: 'message_received',
  });
  if (existing.statusCode !== 1000 || !Array.isArray(existing.data)) {
    throw new Error('Failed to load the saved workflow attachment');
  }
  const attachments = existing.data.filter((a: any) =>
    (!a.channel || a.channel === 'whatsapp') &&
    (!a.channelIdentifier || a.channelIdentifier === phoneId));
  let selected = flowId && attachments.find((a: any) => a.flowId === flowId);
  if (flowId && !selected) {
    const created = await api.createFlowAttachment({
      flowId, scope: 'channel_settings', attachedTo: settingsId,
      channel: 'whatsapp', channelIdentifier: phoneId,
      triggerType: 'message_received',
    });
    if (created.statusCode !== 1000 || !created.data?._id) {
      throw new Error('Failed to attach the selected workflow');
    }
    selected = created.data;
  }
  // Create the replacement first so a failed creation preserves the old flow.
  for (const attachment of attachments) {
    if (attachment._id === selected?._id) continue;
    const removed = await api.deleteFlowAttachment(attachment._id);
    if (removed.statusCode !== 1000) throw new Error('Failed to remove the previous workflow attachment');
  }
}
